









import Vue from 'vue'
import dayjs from 'dayjs'
export default Vue.extend({
  props: {
    columns: {
      type: Array,
      default: () => ([])
    },
    dataValue: {
      type: Array,
      default: () => ([])
    },
    index: {
      type: Number,
      default: null
    },
  },
  data(){
    return {
      tableColumns: [{
          dataIndex: "index",
          key: "index",
          title:this.$t('serial_number'),  //  "序号",
          customRender: (_, record, index) => {
            return index + 1;
          },
          width: 50,
        },{
          dataIndex: "workStationName",
          title:this.$t('page_andon_call_station'),  // "呼叫工位",
          width: 150,
        },{
          dataIndex: "andonTypeCode",
          title:this.$t('page_andon_call_type_code'),  // "呼叫类型编码",
          width: 150,
        },
        {
          dataIndex: "andonTypeName",
          title:this.$t('page_andon_call_type_name'),  //"呼叫类型名称",
          width: 150,
        },
        {
          dataIndex: "andonReasonCode",
          title: this.$t('page_andon_call_reason_code'),  // "呼叫原因编码",
          width: 150,
        },
        {
          dataIndex: "andonReasonName",
          title:this.$t('page_andon_call_reason_name'),  // "呼叫原因名称",
          width: 150,
        },{
          dataIndex: "number",
          title:this.$t('page_andon_call_call_number'),  // "呼叫次数",
          width: 150,
        },{
          dataIndex: "callTime",
          title:this.$t('page_andon_call_call_time'),  // "呼叫时间",
          width: 150,
          customRender: (text, _record, index) => {
            if(text){
              return dayjs(text).format('YYYY-MM-DD HH:mm:ss');
            }else{
              return ''
            }
          },
        },{
          dataIndex: "finishTime",
          title:this.$t('page_andon_call_finish_time'),  // "结束时间",
          width: 150,
          customRender: (text, _record, index) => {
            if(text){
              return dayjs(text).format('YYYY-MM-DD HH:mm:ss');
            }else{
              return ''
            }
          },
        },{
          dataIndex: "description",
          title:this.$t('page_plan_description'),  // "描述",
          width:150
        }],
      tableData: []
    }
  },
  mounted(){
    this.initTableData();
  },
  methods:{
    initTableColumns(){
      this.tableColumns = [{
        title: this.$t('page_operation_statistics_workstationname'),
        dataIndex: 'title',
        key: 'title',
        width: 100
      }]
      this.columns.forEach(item => {
        const value = {
          title: item.wcsName,
          dataIndex: item.wcsName,
          key: item.wcsName,
          width: 100
        }
        this.tableColumns.push(value)
      });
      this.initTableData()
    },
    initTableData(){
      this.tableData = [...this.dataValue];
    }
  }
})

